import api from "@/api";
import Moment from 'moment';
import store from '.';
import Vue from 'vue';


export default {
    namespaced: true,
    state: {
        meetingInfo: null,
        createMeetingLoading: true,
        authorizeURI: "",
        authCode: "",
        state: "",
        accessToken: "",
        hasCancel:false,

    },
    getters: {
        accessToken: (state) => {
            return state.accessToken;
        },  
        authorizeURI: (state) => {
            return state.authorizeURI;
        },                
    },
    mutations: {
        setCreateMeetingLoaded(state){
            state.createMeetingLoading = false;
        },
        setHasCancel(state,hasCancel = true){
            state.hasCancel = hasCancel;
        },
        setObjectMeetingInfo (state, meetingInfo) {
            if (meetingInfo) {
                let { startTime, endTime, password } = meetingInfo;
                let startTimeDate = Moment(startTime * 1000).format('YYYY-MM-DD');
                let startTimeHouer = Moment(startTime * 1000).format('H:mm');
                let endTimeDate = Moment(endTime * 1000).format('YYYY-MM-DD');
                let endTimeHouer = Moment(endTime * 1000).format('H:mm');
                startTime = `${startTimeDate} ${startTimeHouer}`;
                endTime = startTimeDate != endTimeDate
                    ? `${endTimeDate} ${endTimeHouer}`
                    : endTimeHouer;
                meetingInfo['startTime'] = startTime;
                meetingInfo['endTime'] = endTime;
                meetingInfo['password'] = password == '' ? 0 : password;
                meetingInfo['hostsName'] = meetingInfo['hosts'].map((item) => {
                    let name = ''
                    if(process.env.VUE_APP_IS_CLOUD == 1){
                        name = item['username'] ? `${item['username']}` : '';
                    }else{
                        name = item['userid'];
                        name += item['username'] ? `(${item['username']})` : '';
                    }
                    return name;
                });
                meetingInfo['participantsName'] = meetingInfo['participants'] ? meetingInfo['participants'].map((item) => {
                    let name = ''
                    if(process.env.VUE_APP_IS_CLOUD == 1){
                        name = item['username'] ? `${item['username']}` : '';
                    }else{
                        name = item['userid'];
                        name += item['username'] ? `(${item['username']})` : '';
                    }                    
                    return name;
                }) : [];
            }
            state.meetingInfo = meetingInfo;
        },
        setAuthorizeURI(state, authorizeURI){
            state.authorizeURI = authorizeURI;
        },    
        setAuthCode(state, authCode){
            state.authCode = authCode;
        },            
        setState(state, value){
            state.state = value;
        },
        setAccessToken(state, accessToken){
            state.accessToken = accessToken;
        },
        markMeetingCreated(state, created) {
            state.meetingInfo.created = created;
        }
    },
    actions: {
        async getObjectMeetingInfo ({ commit }, { objectType, objectId, afterCreate }) {
            const meetingInfo = await api.meeting.getStatus(objectType, objectId);
            if(meetingInfo && meetingInfo.meetingId){
                commit('setHasCancel', false);
                commit('setObjectMeetingInfo', meetingInfo);
                afterCreate && commit('markMeetingCreated', true);
            }else{
                 commit('setHasCancel', true);
            }
        },
        async setObjectMeetingInfo ({ commit }, { meetingInfo }) {
            commit('setObjectMeetingInfo', meetingInfo);
        },
        async authorize({ commit }, callback) {
            let res = await api.meeting.authorize();
            commit('setState', res.state);
            let redirect = process.env.BASE_URL + '/#/' + store.state.companyId + '/' + store.state.workspaceId + '/meeting/authorize/callback?cb=' + callback + '&code=' + store.state.code;
            console.log('router info authorize redirect', redirect);
            let params = new URLSearchParams({
                corp_id: res.corpId,
                sdk_id: res.sdkId,
                redirect_uri: encodeURI(redirect),
                state: res.state
              });
            console.log('router info authorize redirect state token', res.state, store.getters.apiToken);
            Vue.localStorage.set(res.state, store.getters.apiToken)
            commit('setAuthorizeURI', res.uri + '?' + params.toString());
        },
        async authorizeCallback({ commit }, { auth_code, state }) {
            await api.meeting.authorizeCallback( {auth_code, state} );
            commit('setAuthCode', auth_code);
            commit('setState', state);
        },
        async authorizeGet({ commit }) {
            try {
                let res = await api.meeting.authorizeGet();
                commit('setAccessToken', res.accessToken);
            } catch (e) {
                console.log(e)
            }
        }, 
        async stateGet({ commit }) {
            let res = await api.meeting.stateGet();
            commit('setState', res.state);            
        },               
    }
}